/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	SET_PROVINCES(state, provinces) {
		state.provinces = provinces;
	},
	SET_PLACES(state, places) {
		state.places = places;
	},
	SET_PRODUCTS(state, products) {
		state.products = products;
	},
	SET_SELLS(state, products) {
		state.sells = products;
	},
	SET_SUPPLIERS(state, suppliers) {
		state.suppliers = suppliers;
	},
	SET_MYORDERS(state, myOrders) {
		state.myOrders = myOrders;
	},
	SET_MYORDERS_TOTAL(state, myOrdersTotal) {
		state.myOrdersTotal = myOrdersTotal;
	},
	SET_MATCHINGS(state, matchings) {
		state.matchings = matchings;
	},
	SET_MATCHINGS_TOTAL(state, matchingsTotal) {
		state.matchingsTotal = matchingsTotal;
	},
	SET_SHIPPINGS(state, shippings) {
		state.shippings = shippings;
	},
	SET_SHIPPINGS_TOTAL(state, shippingsTotal) {
		state.shippingsTotal = shippingsTotal;
	},
	SET_SELLS_TOTAL(state, sellTotal) {
		state.sellTotal = sellTotal;
	},
};
